import React from 'react'
import PropTypes from 'prop-types'

import { ChevronIcon, CommentIcon } from '@boltui/icons'

import ChatLogo from '../../components/LiveChat/ChatLogo'

import './LiveChat.scss'

class LiveChat extends React.Component {
  static propTypes = {
    actions: PropTypes.object,
    chatLoading: PropTypes.bool,
    chatOnline: PropTypes.bool,
    chatHasEnded: PropTypes.bool
  }

  handleChatToggle = () => {
    if (this.props.chatHasEnded === true) {
      return this.props.actions.toggleChat({ chatReset: true, chatHasEnded: false })
    }

    return this.props.actions.toggleChat({ chatIsHidden: false, chatIsMinimized: false })
  }

  render () {
    const { chatLoading, chatOnline } = this.props

    return (
      <div className='chat-cta'>
        {chatOnline &&
          <React.Fragment>
            <p className='chat-cta__title'>Still stuck? We're online</p>
            <button
              disabled={chatLoading}
              className='chat-cta__button button button--purple button--secondary button--half'
              onClick={this.handleChatToggle}
            >
              <ChatLogo online width={29} height={29} />
              <span className='chat-cta__label'>
                Live chat now
              </span>
              <ChevronIcon height='20px' width='20px' dir='right' className='chat-cta__chevron' />
            </button>
          </React.Fragment>
        }

        {!chatOnline &&
          <React.Fragment>
            <p className='chat-cta__title'>Still stuck?</p>
            <a
              href='/help/contact-us'
              disabled={chatLoading}
              className='chat-cta__button button button--purple button--secondary button--half'
            >
              <CommentIcon height='40px' width='40px' className='chat-cta__contact-icon' />
              <span className='chat-cta__label'>
                Contact Us
              </span>
              <ChevronIcon height='20px' width='20px' dir='right' className='chat-cta__chevron' />
            </a>
          </React.Fragment>
        }
      </div>
    )
  }
}

export default LiveChat
